import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const silentPush = defineConnector({
  identifier: "silentPush",
  name: "Silent Push",
  tagLine: "Explore API for threat intelligence lookups",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api.silentpush.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "X-API-KEY",
        value: app.secret.apiKey,
      },
    ]),
  steps: [
    {
      title: "Create an API key for the Explore API",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://help.silentpush.com/docs/silent-push-explore-api](https://help.silentpush.com/docs/silent-push-explore-api) to create an API key for the Silent Push Explore API. Silent Push documents this API with the `X-API-KEY` request header.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder:
            "https://api.silentpush.com/api/v1/merge-api/explore/domain/domaininfo/silentpush.com",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url:
        testUrl ??
        (() =>
          "https://api.silentpush.com/api/v1/merge-api/explore/domain/domaininfo/silentpush.com")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
